import ApiClient, { type ResponseType } from '@/helpers/ApiClient';
import axiosInstance from '@/helpers/HTTPClient';

class ConversationsApi extends ApiClient {
  constructor() {
    super('conversations');
  }

  public uploadFileWithProgress(formData: FormData, resource: string, config: any = {}): Promise<ResponseType> {
    return axiosInstance.post<any, ResponseType>(`${this.url}/${resource}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      ...config,
    });
  }
}

export default new ConversationsApi();
